import CustomerDataLoad from './CustomerDataLoad'

export default CustomerDataLoad
